import React from 'react';
import { Grid } from '@mui/material';
import UploadImageSortableItem from './uploadImageSortableItem';

function UploadImageSortableList({ 
  images, 
  setImages, 
  alt, 
  cropable = false,
  cropAcpectRatio = 1,
  deleteItem = () => {}, 
  replaceIitem = () => {}, 
}) {

  const moveItem = (dragIndex, hoverIndex) => {
    const updatedItems = [...images];
    const [movedItem] = updatedItems.splice(dragIndex, 1);
    updatedItems.splice(hoverIndex, 0, movedItem);
    setImages(updatedItems);
  };

  return (
    <>
      <Grid container spacing={2} marginTop={0}>
          {
            images.map((image, index) => (
              <UploadImageSortableItem 
                key={index}
                image={image}
                index={index}
                alt={alt}
                moveItem={moveItem}
                deleteItem={deleteItem}
                replaceIitem={replaceIitem}
                cropable={cropable}
                cropAspectRatio={cropAcpectRatio}
              />
            ))
          }
      </Grid>
    </>
  )
}

export default UploadImageSortableList;